<template>
  <div :class="classEffect3" class="intro">
    <div :class="classEffect" class="ty-motion" ref="tyMotion" id="tyMotion" />
    <div :class="classEffect2" class="ty-motion blend">
      BLEND IT
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions } from "vuex";
import { gsap, TimelineLite, TextPlugin } from "gsap/all";
gsap.registerPlugin(TextPlugin);
export default {
  name: "Intro",
  components: {},
  data() {
    return {
      tl: "",
      classEffect: "",
      classEffect2: "",
      classEffect3: ""
    };
  },
  methods: {
    ...mapActions("common", {
      setIntroAction: "setIntro"
    })
  },
  mounted() {
    const { tyMotion } = this.$refs;
    this.tl = new TimelineLite();
    this.tl
      .to(tyMotion, 1, { text: { value: "FORE" }, delay: 0.5 })
      .to(tyMotion, 0.5, { text: { value: "FORE SIGHT" }, delay: 0.3 })
      .to(tyMotion, 0.5, { text: { value: "FORE MOVE" }, delay: 0.3 })
      .to(tyMotion, 0.5, { text: { value: "FORE POSSESSION" }, delay: 0.3 })
      .to(tyMotion, 0.5, { text: { value: "FORE MOST" }, delay: 0.3 })
      .to(tyMotion, 1, {
        onComplete: () => {
          this.classEffect = "step1";
        }
      })
      .to(tyMotion, 1, {
        onComplete: () => {
          this.classEffect = "step1 step2";
        }
      })
      .to(tyMotion, 0.3, {
        onComplete: () => {
          this.classEffect2 = "step3";
        }
      })
      .to(tyMotion, 1, {
        onComplete: () => {
          this.classEffect = "step1 step2 step4";
          this.classEffect2 = "step4";
        }
      })
      .to(tyMotion, 0.3, {
        onComplete: () => {
          this.classEffect3 = "step5";
          this.setIntroAction("logo");
          Vue.$cookies.set("intro", "false", 60 * 60 * 24);
        }
      });
  }
};
</script>

<style lang="scss" scoped>
.intro {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  background: #000;
  .ty-motion {
    position: absolute;
    left: 10vw;
    top: 50%;
    font-family: attribute-mono, sans-serif;
    font-size: 28px;
    font-weight: 500;
    color: #fff;

    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 0;
      height: 40px;
    }
    &:before {
      background-image: linear-gradient(to right, #ff5583, #cc91ff 36%, #60aaff 64%, #9eff7b);
      -webkit-animation: spin 0.6s linear infinite;
    }
    &:after {
      background: #fff;
    }
    &.step1:before {
      width: 80vw;
      transition: width 0.6s ease-in-out;
    }
    &.step2:after {
      width: 80vw;
      transition: width 0.6s ease-in-out;
    }
    &.blend {
      overflow: hidden;
      width: 0;
      white-space: nowrap;
      margin-top: -8.5vw;
      font-size: 18vw;
      font-weight: bold;
    }
    &.blend:before,
    &.blend:after {
      display: none;
    }
    &.blend.step4 {
      display: none;
    }
    &.step3 {
      width: 100%;
      transition: width 0.6s ease-in-out;
    }
    &.step4 {
      left: 0;
      right: 0;
      width: 100vw;
      transition: all 0.3s;
    }
    &.step4:before {
      top: -50vh;
      background: #fff;
      transition: top 0.3s, width 0.3s, height 0.3s, background 0s;
    }
    &.step4:after {
      bottom: -30vh;
      transition: bottom 0.3s, width 0.3s, height 0.3s;
    }
    &.step4:before,
    &.step4:after {
      width: 100vw;
      height: 50vh;
    }
  }
  &.step5 {
    opacity: 0;
    transition: opacity 0.5s;
  }
}

/* mobile */
@media (max-width: 890px) {
  .intro {
    .ty-motion {
      font-size: 3.146vw;

      &:before,
      &:after {
        height: 4.494vw;
      }
    }
  }
}
</style>
